import React from "react";
import Logo from "./Logo";

export default function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-bhyyve-bg/80 backdrop-blur-md" data-testid="founding-header">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-8 py-6">
        <Logo />
        <nav className="hidden md:flex items-center gap-10 text-base font-medium text-bhyyve-muted">
          <a href="#how-it-works" className="hover:text-bhyyve-ink transition-colors">How it Works</a>
          <a href="#contact" className="hover:text-bhyyve-ink transition-colors">Contact</a>
        </nav>
        <a
          href="#waitlist"
          className="bg-bhyyve-charcoal text-white text-sm font-semibold px-6 py-3 rounded-full hover:bg-bhyyve-charcoalSoft transition-colors"
          data-testid="header-cta"
        >
          Join Waitlist
        </a>
      </div>
    </header>
  );
}
